angular.module 'zc.projects'

.controller 'IncentiveShowCtrl', ($scope, $state, $translate, $filter, $q, Page, Incentive, UniqueCouponCode, currentProject, discountTypes, incentive, currencies) ->
  Page.setBodyClass ''
  $translate('projectsIncentives.show.incentiveDetails').then((translation) ->
    Page.setTitle(translation)
  )

  $scope.incentive = incentive
  $scope.currentProject = currentProject
  $scope.discountTypes = discountTypes

  $scope.currency = currencies[$scope.currentProject.currency]
  $scope.currencyStep = 1 / 10 ** $scope.currency.fractionSize
  $scope.discount_price = $scope.incentive.discount_price * $scope.currencyStep if $scope.incentive.discount_price
  $scope.minimum_price = $scope.incentive.minimum_price * $scope.currencyStep if $scope.incentive.minimum_price

  if incentive.incentive_type is 'unique_coupon_code'
    $scope.totalUniqueCouponCodeCount = 0
    $scope.assignedUniqueCouponCodeCount = 0
    query =
      projectId: $scope.incentive.project_id
      incentiveId: $scope.incentive.id
    $q.all [
      UniqueCouponCode.count(query)
      UniqueCouponCode.count(_.assignIn({assigned: 1}, query))
    ]
    .then ([totalUniqueCouponCodeCount, assignedUniqueCouponCodeCount]) ->
      $scope.totalUniqueCouponCodeCount = totalUniqueCouponCodeCount
      $scope.assignedUniqueCouponCodeCount = assignedUniqueCouponCodeCount



// WEBPACK FOOTER //
// ./src/zenclerk_modules/projects.incentives/show.controller.coffee